import { ColorModeScript, ChakraProvider, extendTheme } from "@chakra-ui/react";
import * as ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from "./serviceWorker";
// Inter, latin subset woff2 (font-display: swap), the weights the app uses
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/inter/latin-600.css";
import "@fontsource/inter/latin-700.css";
import { BidsProvider } from "./context/BidsContext";
import { EquipmentProvider } from "./context/EquipmentContext";
import { LoadsProvider } from "./context/LoadsContext";
import { ChatProvider } from "./context/ChatContext";
import { DriverProvider } from "./context/DriverContext";
import { DashboardProvider } from "./context/DashboardContext";

const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");
const root = ReactDOM.createRoot(container);

const theme = extendTheme({
  fonts: {
    heading: `'Inter', sans-serif`,
    body: `'Inter', sans-serif`,
    // heading: `'Inter-Bold', sans-serif`,
    // body: `'Inter-normal', sans-serif`,
  },
  colors: {
    error: "#ff3333",
    primary: {
      // 100: "#0A53BF",
      // 900: "primary.500",
      100: "#79a0a0",
      500: "#017172",
      900: "#017172",
    },
    dark: {
      100: "#8C8C8C",
      200: "#1F1F1F",
      500: "#454545",
      900: "#454545",
    },
    grey: {
      100: "#EBEEF2",
      150: "#AEAEAE",
      200: "#D9D9D9",
      300: "#EBEEF2",
      500: "#8C8C8C",
    },
    customBlue: {
      100: "#E9EFFD",
      500: "#0A53BF",
      900: "#0A53BF",
    },
    customOrange: {
      100: "#FDF1EA",
      500: "#EA702E",
      900: "#EA702E",
    },
  },
  fontSizes: {
    base: "16px",
    xs: "16px",
    sm: "16px",
    md: "16px",
  },
});

root.render(
  <ChakraProvider theme={theme}>
    <ColorModeScript />
    <EquipmentProvider>
      <DriverProvider>
        <LoadsProvider>
          <ChatProvider>
            <BidsProvider>
              <DashboardProvider>
                <App />
              </DashboardProvider>
            </BidsProvider>
          </ChatProvider>
        </LoadsProvider>
      </DriverProvider>
    </EquipmentProvider>
  </ChakraProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
